<template>
	<b-form
		ref="form"
		@submit.prevent="add"
	>
		<b-row class="mt-3">
			<b-col cols="12">
				<b-form-group
					label="Name:"
					for="name"
				>
					<b-input
						id="name"
						v-model="subMaterial.Name"
						type="text"
					
						required
					/>
				</b-form-group>
			</b-col>

			<b-col cols="4">
				<b-button
					type="submit"
					variant="info"
				>
					Add
				</b-button>
			</b-col>

			<b-col cols="6">
				<span
					class="text-danger"
					v-if="postError"
				>{{ postError }}</span>
			</b-col>

		</b-row>

	</b-form>
</template>


<script>
import MaterialService from "@/api-services/material.service";

export default {
	name: "AddSubMaterial",

	props: ['materialId'],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			subMaterial: {
				MaterialId: this.materialId,
				Name: '',
			},

			postError:'',
		};
	},

	// things we do to data
	methods: {
		add() {
			MaterialService.createSubMaterial(this.materialId, this.subMaterial)
				.then((response) => {
					// push this sucka back to the parent
					let newSubMaterial = response.data;
					this.$emit("addSubMaterial", newSubMaterial);
				})
				.catch((error) => {
					this.postError = error.response.data.Message;
				});
		},

	},
};
</script>



// WEBPACK FOOTER //
// src/components/partials/add-submaterial.vue